export const en = {
    sync_documents: 'Synchronize with Yandex ID',
    something_went_wrong: 'Something went wrong, contact support chat',
};
